import useUserContext from "./useUserContext";

const ALLOWED_FLAG_DOMAINS = new Set([
  "vuelve.co",
  "quick-shirt-picker.myshopify.com",
  "sssurfer.myshopify.com",
]);

type FlagPredicate = () => boolean;

const read = (key: string) => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(key);
};

const FLAG_PREDICATES: Record<string, FlagPredicate> = {
  v2: () => read("v2") === "1",
  "automation.show_step_number": () => read("v2_automation_show_step_number") === "1",
  "automation.lab.inner_tools": () => read("v2_automation_lab_inner_tools") === "1",
  "copilot.testing_mode": () => read("v2_copilot_testing_mode") === "1",
  "copilot.platform.shopify": () => read("v2_copilot_platform_override") === "shopify",
  "copilot.platform.woo": () => read("v2_copilot_platform_override") === "woo",
  "copilot.platform.independent": () => read("v2_copilot_platform_override") === "independent",
  "copilot.mock.twilio_purchase.success": () => read("v2_mock_twilio_purchase") === "success",
  "copilot.mock.twilio_purchase.failure": () => read("v2_mock_twilio_purchase") === "failure",
  "copilot.mock.meta_onboarding.success": () => read("v2_mock_meta_onboarding") === "success",
  "copilot.mock.meta_onboarding.failure": () => read("v2_mock_meta_onboarding") === "failure",
};

const useFlag = () => {
  const { selectedDomain } = useUserContext();

  const isFlagOn = (flagKey: string): boolean => {
    const normalizedDomain = String(selectedDomain || "").trim().toLowerCase();
    if (!ALLOWED_FLAG_DOMAINS.has(normalizedDomain)) return false;
    const resolver = FLAG_PREDICATES[flagKey];
    if (!resolver) return false;
    return Boolean(resolver());
  };

  return { isFlagOn };
};

export default useFlag;
